"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IOptions_1 = require("./WrappedProperty/IOptions");
var WrappedProperty_1 = require("./WrappedProperty");
var fixAndMergeSchema_1 = require("./JSchema/fixAndMergeSchema");
var defaultValue_1 = require("./JSchema/defaultValue");
var fixData_1 = require("./JSchema/fixData");
/**
 * czy to jest prosty model
 *
 * @export
 * @param {*} model model wejściowy
 * @param {number} [maxPropCount=100] maksymalna dopuszczalna liczba wlasciwości
 * @param {IRefCount} [refCount] informacje wewnętrzne
 * @returns {boolean} czy liczba włąsciwości nie przekaracza max
 */
function isModelSimple(model, maxPropCount, refCount) {
    if (maxPropCount === void 0) { maxPropCount = 100; }
    refCount = refCount || { count: 0 };
    if (model === undefined) {
        return false;
    }
    if (Array.isArray(model)) {
        refCount.count += model.length;
        if (refCount.count > maxPropCount)
            return false;
        for (var _i = 0, model_1 = model; _i < model_1.length; _i++) {
            var item = model_1[_i];
            if (!isModelSimple(item, maxPropCount, refCount)) {
                return false;
            }
        }
    }
    else if (typeof model === 'object' && model) {
        for (var key in model) {
            if (!isModelSimple(model[key], maxPropCount, refCount)) {
                return false;
            }
        }
    }
    else {
        if (++refCount.count > maxPropCount)
            return false;
    }
    return true;
}
exports.isModelSimple = isModelSimple;
var schemaMixin = {
    beforeCreate: function () {
        var vm = this;
        // constructor
        var Vue = vm.constructor;
        while (Vue.super) {
            Vue = Vue.super;
        }
        if (Vue.Renderless) {
            Vue = Vue.Renderless;
        }
        vm.$VueConstructor = Vue;
        vm.$methods = Vue.prototype.$methods = IOptions_1.defaultOptions.schemaMethods;
    },
    created: function () {
        var vm = this;
        var schema = vm.$options.schema;
        if (schema && vm.$setSchema) {
            vm.$setSchema(schema, false);
        }
    },
    beforeDestroy: function () {
        this.$setSchema();
    },
    methods: {
        $setSchema: function (schema, forceUpdate) {
            var vm = this;
            if (vm.$schema) {
                vm.$schema.$destroy();
            }
            vm.$schema = undefined;
            if (!schema) {
                return undefined;
            }
            if (vm.model === undefined) {
                throw new Error('no `model` property in data');
                return undefined;
            }
            var soptions = IOptions_1.defaultOptions;
            soptions.Vue = vm.$VueConstructor;
            if (vm.$options.external) {
                soptions.external = vm.$external = vm.$options.external;
            }
            vm.$form = soptions.form = vm.form || {};
            var schema2 = null;
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.time('schema fixing time');
            }
            var sopts = vm.schemaOptions || vm.$options.schemaOptions;
            var fixOptions = Object.assign({}, fixAndMergeSchema_1.fixSchemaDefaultOptions);
            if (sopts && sopts.arrayItemGuidField !== undefined) {
                fixOptions.arrayItemGuidField = sopts.arrayItemGuidField;
            }
            else {
                if (schema.$options && schema.$options.arrayItemGuidField !== undefined) {
                    fixOptions.arrayItemGuidField = schema.$options.arrayItemGuidField;
                }
            }
            fixOptions.model = vm.model;
            if (!Array.isArray(schema)) {
                schema = [schema];
            }
            else {
                schema = schema.slice(0);
            }
            if (vm.$options.beforeFixSchema) {
                vm.$options.beforeFixSchema.call(vm, schema, fixOptions);
            }
            schema2 = fixAndMergeSchema_1.default(schema, fixOptions);
            // sprawdzenie options w schema
            if (schema2.$options) {
                IOptions_1.mergeOptions(soptions, schema2.$options);
            }
            // sprawdzenie options
            if (sopts) {
                IOptions_1.mergeOptions(soptions, sopts);
            }
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.timeEnd('schema fixing time');
            }
            var nfix = soptions.fixData;
            if (vm.model === null) {
                // tworzenie domyslnego
                if (nfix) {
                    vm.model = defaultValue_1.default(schema2, true);
                }
                else {
                    vm.model = {};
                }
            }
            else {
                if (nfix) {
                    if (process.env.NODE_ENV === 'development') {
                        // tslint:disable-next-line: no-console
                        console.time('fixData');
                    }
                    var fixed = fixData_1.default(schema2, vm.model, soptions.Vue);
                    if (process.env.NODE_ENV === 'development') {
                        // tslint:disable-next-line: no-console
                        console.timeEnd('fixData');
                        if (fixed) {
                            // tslint:disable-next-line: no-console
                            console.log('fixed fields: ' + fixed);
                        }
                    }
                }
            }
            // automatyczne wrapAll gdy model ma niej niż 100 elementów
            if (!soptions.wrapAll && isModelSimple(vm.model, 100)) {
                soptions.wrapAll = true;
            }
            if (vm.$options.beforeSchema) {
                vm.$options.beforeSchema.call(vm, vm.model, schema2, soptions);
            }
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.time('wrapping schema');
            }
            vm.$schema = new WrappedProperty_1.default[schema2.type](null, vm, 'model', schema2, soptions);
            if (process.env.NODE_ENV === 'development') {
                // tslint:disable-next-line: no-console
                console.timeEnd('wrapping schema');
            }
            if (vm.$options.afterSchema) {
                vm.$options.afterSchema.call(vm, vm.$schema);
            }
            if (forceUpdate && vm.$forceUpdate) {
                vm.$forceUpdate();
            }
            return vm.$schema;
        }
    }
};
exports.default = schemaMixin;
//# sourceMappingURL=schemaMixin.js.map